import React from "react";
import { DateTime } from "luxon";

import { Context } from "../../context";
import { Props } from "./types";
import { Month } from "./month";
import styles from "./styles.scss";

function isMonthStart(dt: DateTime) {
  return dt.day === 1;
}

function startMonth(months: DateTime[][], startDate: DateTime) {
  return [...months, [startDate]];
}

function isInMonth([firstDt]: DateTime[], dt: DateTime) {
  return firstDt.month === dt.month && firstDt.year === dt.year;
}

function findMonthIndex(months: DateTime[][], dt: DateTime) {
  return months.findIndex((month) => isInMonth(month, dt));
}

function addToMonth(months: DateTime[][], dt: DateTime) {
  const index = findMonthIndex(months, dt);

  return index >= 0
    ? [
        ...months.slice(0, index),
        [...months[index], dt],
        ...months.slice(index + 1),
      ]
    : [...months, [dt]];
}

function getMonths(dates: DateTime[]) {
  return dates.reduce<DateTime[][]>(
    (months, dt) =>
      isMonthStart(dt) ? startMonth(months, dt) : addToMonth(months, dt),
    [],
  );
}

function Months({ dates, useWeeks = true }: Props) {
  const { cell } = React.useContext(Context);

  return (
    <div className={styles.months}>
      {getMonths(dates).map((month, index) => (
        <div
          key={index}
          className={styles.month}
          style={{
            width: cell.width * month.length,
            height: useWeeks
              ? cell.height + (cell.height + cell.height * (1 / 3))
              : cell.height,
          }}
        >
          <Month month={month} useWeeks={useWeeks} />
        </div>
      ))}
    </div>
  );
}

export { Months };
